var OrderSearchForm = (function ($) {

    OrderSearchForm = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$checkin_block = options['$checkin_block'];
        that.$checkbox_checkin = that.$checkin_block.find('.js-checkin');

        that.$form = that.$wrapper.find('form');
        that.$submit_button = that.$wrapper.find('.js-submit');
        that.$input_pnr = that.$wrapper.find('.js-pnr');
        that.$input_lastname = that.$wrapper.find('.js-lastname');
        that.$hint_input = that.$wrapper.find('.js-icon-visible');

        // CONST
        that.modal = options['modal'];
        that.is_checkin = options['is_checkin'];
        that.chekin_url = options['checkin_url'];
        that.locale = options['locale'];
        
        that.only_ticket_number = options['only_ticket_number'];
        that.pnr_length = options['pnr_length'];
        that.ticket_number_length = options['ticket_number_length'];
        that.not_found_by_ticket_code = options['not_found_by_ticket_code'];
        that.search_url = $.sa.build_url('order/search/perform');

        that.input_pnr_error_symbol = that.$input_pnr.data('error-symbol');
        that.input_pnr_error_length = that.$input_pnr.data('error-text');
        that.input_ticket_number_error_length = that.$input_pnr.data('error-ticket-length-text');
        that.input_pnr_error_empty_length = that.$input_pnr.data('error-empty-length');

        that.classes = {
            tooltip_empty: 'js-tooltip-error-empty',
            tooltip_format: 'js-tooltip-error-format',
            hidden: 'hidden',
            not_empty: 'not-empty',
            subtitle: 'js-subtitle',
            subtitle_pnr: 'js-subtitle-pnr',
            modal_requirements_ticket_number: 'js-ticket-number',
            error: 'error',
            input: 'input',
            hint_wrapper: 'hint-wrapper',
            is_active: 'is-active'
        };

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    OrderSearchForm.prototype.init = function () {
        var that = this;

        that.initFields();
        //
        that.initSubmit();
    };

    OrderSearchForm.prototype.initFields = function () {
        var that = this;

        that.__setLastNameMask(that.$input_lastname);
        that.__initOnBlurValidate(that.$input_lastname, 'lastname');

        if (!that.only_ticket_number) {
            that.__setPnrTicketMask(that.$input_pnr);
            that.__initOnBlurValidate(that.$input_pnr, 'pnr', true);
        } else {
            that.__setPnrTicketMask(that.$input_pnr, false);
            that.__initOnBlurValidate(that.$input_pnr, 'only_ticket_number', true);
        }

        if (that.is_checkin) {
            that.__initOnBlurValidate(that.$checkbox_checkin, 'checkin');
            that.$checkbox_checkin.change(function () {
                that.__validateValue(that.$checkbox_checkin, 'checkin');
            });
        }

        that.$hint_input.on('click', function () {
            var $this = $(this),
                $input = $this.siblings('input');

            UIInput.prototype.clearError($input);
        });
    }

    OrderSearchForm.prototype.__setPnrTicketMask = function ($input, with_pnr = true) {
        var that = this,
            mask_options = {with_pnr: with_pnr};
        
        UIInputMask.prototype.initPnrMask(that.$wrapper, mask_options);
    };

    OrderSearchForm.prototype.__setLastNameMask = function ($input) {
        var that = this,
            complete = false;

        $input.inputmask({
            mask: [
                'b{*}'
            ],

            definitions: {
                'b': {
                    // both: cyrillic + latin
                    validator: '[ \u0041-\u005A\u0061-\u007A\u0401\u0451\u0410-\u0429\u042B-\u0449\u044B-\u044F]',
                    casing: UIInputMask.prototype.CASING.upper
                }
            },
            inputmode: UIInputMask.prototype.INPUTMODE.email,
            placeholder: '',

            onKeyValidation: function (key, result) {
                if (!result && complete === false) {
                    UIInput.prototype.setError($input, that.input_pnr_error_symbol, true);
                } else {
                    UIInput.prototype.clearError($input);
                }
            },
            onKeyDown: function (key) {
                if (key.code === 'Backspace') {
                    UIInput.prototype.clearError($input);
                    complete = false;
                }
            },
            oncomplete: function () {
                complete = true;
            },
            onincomplete: function () {
                complete = false;
            },
            oncleared: function () {
                complete = false;
            }
        });
    };


    OrderSearchForm.prototype.__initOnBlurValidate = function ($input, validation_field, clear = false) {
        var that = this;

        $input.on('blur', function () {
            var $input = $(this),
                value = $.trim($input.val());

            that.__validateValue($input, validation_field, value);
        });
    }

    OrderSearchForm.prototype.__validateValues = function () {
        var that = this,
            is_valid = true;

        if (!that.__validateValue(that.$input_pnr, 'pnr', that.$input_pnr.val())) {
            is_valid = false;
        }

        if (!that.__validateValue(that.$input_lastname, 'lastname', that.$input_lastname.val())) {
            is_valid = false;
        }

        if (that.only_ticket_number && that.$input_pnr.val().length !== that.ticket_number_length) {
            is_valid = false;
        }

        return is_valid;
    }

    OrderSearchForm.prototype.__validateValue = function ($input, field, value = null) {
        var that = this;

        if (that.__isHintActive($input)) {
            return;
        }

        switch (field) {
            case 'pnr':
                $parent_input = $input.parent();

                if (value.length < 1) {
                    $parent_input.find('.' + that.classes.tooltip_empty).removeClass(that.classes.hidden);
                    $parent_input.find('.' + that.classes.tooltip_format).addClass(that.classes.hidden);

                    UIInput.prototype.setError($input, that.input_pnr_error_empty_length, true);
                    return false;
                }

                $parent_input.addClass(that.classes.not_empty);

                if (value.length !== that.pnr_length && value.length !== that.ticket_number_length) {
                    $input.parent().find('.' + that.classes.tooltip_empty).addClass(that.classes.hidden);
                    $input.parent().find('.' + that.classes.tooltip_format).removeClass(that.classes.hidden);

                    UIInput.prototype.setError($input, that.input_pnr_error_length, true);
                    return false;
                }

                break;

            case 'only_ticket_number':
                $parent_input = $input.parent();

                if (value.length < 1) {
                    $parent_input.find('.' + that.classes.tooltip_empty).removeClass(that.classes.hidden);
                    $parent_input.find('.' + that.classes.tooltip_format).addClass(that.classes.hidden);

                    UIInput.prototype.setError($input, that.input_pnr_error_empty_length, true);
                    return false;
                }

                $parent_input.addClass(that.classes.not_empty);

                if (value.length !== that.ticket_number_length) {
                    $input.parent().find('.' + that.classes.tooltip_empty).addClass(that.classes.hidden);
                    $input.parent().find('.' + that.classes.tooltip_format).removeClass(that.classes.hidden);

                    UIInput.prototype.setError($input, that.input_ticket_number_error_length, true);
                    return false;
                }

                break;
            case 'lastname':
                if (value.length < 1) {
                    UIInput.prototype.setError($input);
                    return false;
                }
                break;
            case 'checkin':
                if (!$input.is(':checked')) {
                    UIInput.prototype.setError($input);
                    return false;
                }
                break;
        }

        UIInput.prototype.clearError($input);

        return true;
    };

    OrderSearchForm.prototype.__isHintActive = function ($input) {
        var that = this,
            $parent_input = $input.parent('.' + that.classes.input),
            $hint_wrapper = $parent_input.find('.' + that.classes.hint_wrapper);

        return $hint_wrapper.hasClass(that.classes.is_active);
    };

    OrderSearchForm.prototype.__getSerializedFormData = function () {
        var that = this;
        return that.$form.serializeArray();
    };

    OrderSearchForm.prototype.__isTicketNumber = function () {
        var that = this;
        return $.trim(that.$input_pnr.val()).length === that.ticket_number_length;
    };

    OrderSearchForm.prototype.initSubmit = function () {
        var that = this,
            is_locked = false;

        that.$form.on('submit', function (e) {
            e.preventDefault();

            if (!that.__validateValues()) {
                return;
            }

            var data = that.__getSerializedFormData();

            if (that.is_checkin) {
                that.redirectCheckin(data[0]['value'], data[1]['value']);
                return;
            }

            if (is_locked) {
                return false;
            }
            is_locked = true;

            $.sa.buttonLoading(that.$submit_button, true);

            $.post(that.search_url, data, function (res) {
                if (!res) {
                    res = {
                        status: 'fail',
                        errors: [
                            {
                                code: 0,
                                message: $.sa.locales['something_went_wrong'],
                            }
                        ],
                    };
                }

                switch (res.status) {
                    case 'ok':
                        that.__handleSuccess(res, data);
                        break;
                    case 'fail':
                        that.__handleError(res);
                        break;
                }

                is_locked = false;
                $.sa.buttonLoading(that.$submit_button, false);
            });
        });
    }

    OrderSearchForm.prototype.redirectCheckin = function (ticket_number, last_name) {
        var that = this,
            checkin_params = new URLSearchParams({
                ticketNumber: ticket_number,
                lastName: last_name,
                lang: that.locale
            });
        
        window.location.href = that.chekin_url + '?' + checkin_params.toString();
    };

    OrderSearchForm.prototype.__handleSuccess = function (res) {
        $.sa.content_router.load($.sa.build_url('order') + '/' + res.data.order_hash);
    };

    OrderSearchForm.prototype.__handleError = function (res = null) {
        var that = this,
            $not_found_error_modal = $(that.modal['not_found']).clone();

        if (res && res.errors[0] && res.errors[0].code === that.not_found_by_ticket_code) {
            if (!that.only_ticket_number) {
                $not_found_error_modal.find('.' + that.classes.modal_requirements_ticket_number).hide();
            }
            $not_found_error_modal.find('.' + that.classes.subtitle).hide();
            $not_found_error_modal.find('.' + that.classes.subtitle_pnr).show();
        } else {
            $not_found_error_modal.find('.' + that.classes.subtitle_pnr).hide();
            $not_found_error_modal.find('.' + that.classes.subtitle).show();
        }

        var onClose = function () {
            that.$input_pnr.focus();
        };

        $.uiModal({
            mobile_fullscreen: false,
            $wrapper: $not_found_error_modal,
            disable_content_scroll: true,
            onClose: onClose
        });
    };

    return OrderSearchForm;
})($);
